import { render, staticRenderFns } from "./StudentContactCard.vue?vue&type=template&id=e0016dc8&"
import script from "./StudentContactCard.vue?vue&type=script&lang=js&"
export * from "./StudentContactCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports